import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
})
export class BarChartComponent implements OnInit {
@Input() title;
@Input() series;
@Input() categoriesX=["TD", "PRV", "CD"];
@Input() colorFondo: '#ECF4FC'


  optionsChart: any;

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['series'] && changes['series'].currentValue){

      this.optionsChart = {
        chart: {
          type: "bar",
          backgroundColor: this.colorFondo

        },

        xAxis: {
          categories:this.categoriesX
        },
        yAxis: {
          min: 0,
          title: {
            text: "Total de despachos",
          },
        },
        legend: {
          reversed: false,
          itemStyle: {
            fontWeight:'normal',
            fontSize  :'11px'
          }
        },
        plotOptions: {
          series: {
            stacking: 'percent',
            dataLabels: {
              enabled : true,
              style:{
                fontSize  :'11px',
                fontWeight:'normal',
                color     :'black'
              },

              /* format: "{point.percentage:.1f}%", */
              distance: -10,
              filter: {
                property: "percentage",
                operator: ">",
                value   : 10,
              },
            },
          },


        },
        series :this.series
      };
    }
  }


  ngOnInit() {

  }

}
